import { Link, useRouteLoaderData } from 'react-router'
import { Icon } from '../ui/icon'

export default function Footer() {
	const appName = useRouteLoaderData('root')?.ENV.APP_NAME

	return (
		<footer className="bg-gray-900 text-gray-300">
			<div className="container mx-auto px-4 py-8">
				<div className="grid grid-cols-1 gap-8 md:grid-cols-3">
					<div>
						<h3 className="mb-4 text-xl font-bold">{appName}</h3>
						<p className="mb-4">
							Elevate your Instagram presence with AI-powered captions that
							reflect your unique brand personality.
						</p>
					</div>
					<div>
						<h3 className="mb-4 text-lg font-bold">Quick Links</h3>
						<ul className="space-y-2">
							<li>
								<Link
									to="/#features"
									className="flex items-center gap-2 transition hover:text-white"
								>
									<Icon name="link-2" className="h-4 w-4" />
									<span>Features</span>
								</Link>
							</li>
							<li>
								<Link
									to="/#how-it-works"
									className="flex items-center gap-2 transition hover:text-white"
								>
									<Icon name="link-2" className="h-4 w-4" />
									<span>How It Works</span>
								</Link>
							</li>
							<li>
								<Link
									to="/#pricing"
									className="flex items-center gap-2 transition hover:text-white"
								>
									<Icon name="link-2" className="h-4 w-4" />
									<span>Pricing</span>
								</Link>
							</li>
							<li>
								<Link
									to="/login"
									className="flex items-center gap-2 transition hover:text-white"
								>
									<Icon name="lock-closed" className="h-4 w-4" />
									<span>Login</span>
								</Link>
							</li>
							<li>
								<Link
									to="/privacy"
									className="flex items-center gap-2 transition hover:text-white"
								>
									<Icon name="file-text" className="h-4 w-4" />
									<span>Privacy Policy</span>
								</Link>
							</li>
							<li>
								<Link
									to="/terms-of-service"
									className="flex items-center gap-2 transition hover:text-white"
								>
									<Icon name="file-text" className="h-4 w-4" />
									<span>Terms of Service</span>
								</Link>
							</li>
						</ul>
					</div>
					<div>
						<h3 className="mb-4 text-lg font-bold">Contact</h3>
						<ul className="space-y-2">
							<li>
								<Link
									to="mailto:hello@inselect.app"
									className="flex items-center gap-2 transition hover:text-white"
								>
									<Icon name="envelope-closed" className="h-4 w-4" />
									<span>hello@inselect.app</span>
								</Link>
							</li>
						</ul>
					</div>
				</div>
				<div className="mt-8 border-t border-gray-800 pt-6 text-center">
					<p>
						&copy; {new Date().getFullYear()} {appName} by New Arc Consulting.
						All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	)
}
